<div class="form-header-tabs">
  <div class="form-header-title">{{ title }}</div>
  <div class="form-header-tabs-container">
    <div 
      *ngFor="let tab of tabs" 
      class="form-tab"
      [class.active]="isActiveTab(tab.id)"
      [class.inactive]="!isActiveTab(tab.id)"
    >
      <i [class]="tab.icon"></i>
      <span>{{ tab.label }}</span>
    </div>
  </div>
</div>

